import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="site-footer">
            <div><b>Divine Veg on 262</b><span>Fresh vegetarian food, prepared locally.</span></div>
            <div><Link to="/terms-and-conditions">Terms</Link><Link to="/contact-us">Contact</Link></div>
            <small>Copyright {new Date().getFullYear()} Divine Veg on 262</small>
        </footer>
    );
}

export default Footer;
